import React, {useEffect, useRef, useState} from 'react';
import {createBrowserHistory} from 'history';

import SearchJobsFilter from "@/components/SearchJobsFilter.jsx";
import {useFetchData} from "@/hooks/useFetchData.jsx";
import HandleFavoriteButtons from "@/components/favorites/HandleFavoriteButtons.jsx";

let history;
if (typeof window !== 'undefined') {
    history = createBrowserHistory();
}

export default function JobsSearch({redirect = false}) {
    const {
        data,
        isLoading,
        fetchData,
        setEndpoint,
    } = useFetchData({endpoint: '/jobs'});

    const urlRef = useRef(window?.location.pathname);

    useEffect(() => {
        const historyUnlisten = history.listen(({action, location}) => {
            fetch(`${location.pathname}${location.search}`)
        });

        attachPaginationEvents();
        HandleFavoriteButtons();
        addBackgroundForLogo();

        return () => {
            historyUnlisten();
        }
    }, [history]);

    useEffect(() => {
        if (Object.keys(data).length !== 0) {
            handleData();
        }
    }, [data]);

    const fetch = (url) => {
        if (urlRef.current === url) {
            return;
        }

        urlRef.current = url;

        setEndpoint(url);
        fetchData();
    }

    const handleData = () => {
        if (data?.redirect) {
            window.location = data.redirect;
            return;
        }

        document.getElementById('list').innerHTML = data?.jobsHtml ?? '';
        document.getElementById('pagination').innerHTML = data?.paginationHtml ?? '';

        HandleFavoriteButtons();
        attachPaginationEvents();
        addBackgroundForLogo();
    }

    const buildSearchUrl = (keyword, location) => {
        return `/jobs` +
            (location?.slug?.length > 0 ? `/${location.slug}` : '') +
            (keyword?.length > 0 ? `?s=${keyword}` : '');
    }

    const handleSearch = (keyword, location) => {
        if(redirect) {
            window.location = buildSearchUrl(keyword, location);
        } else {
            history.push(buildSearchUrl(keyword, location));
            window.scrollTo(0, 0);
        }
    }

    const attachPaginationEvents = () => {
        document.querySelectorAll('#pagination li a')
            .forEach(link => link.addEventListener('click', (event) => {
                event.preventDefault();
                history.push( event.currentTarget.href);
                window.scrollTo(0, 0);
            }));
    }

    const addBackgroundForLogo = () => {
        const listItems = document.querySelectorAll('#list .image-container');

        const lazyLoadBackground = (entry) => {
            if (entry.isIntersecting) {
                const imgSrc = entry.target.querySelector('img').getAttribute('src');
                entry.target.style.setProperty('--background-image', `url(${imgSrc})`);
                observer.unobserve(entry.target);
            }
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(lazyLoadBackground);
        });

        listItems.forEach((item) => {
            observer.observe(item);
        });
    }

    return (
        <>
            <SearchJobsFilter
                onSubmit={handleSearch}
                mobileStyle={!redirect ? 'one-line' : 'default'}
                initData={{
                    keyword: window?.searchFilter?.keyword ?? '',
                    location: window?.searchFilter?.location ?? {},
                }}
            />
        </>
    );
};

